import React from "react";
import { VictoryLegend, VictoryPie } from "victory";

class PieChart extends React.Component {
  render() {
    return (
      <div>
        <svg
          viewBox="0 0 500 400"
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            maxWidth: "400px",
            maxHeight: "400px",
            margin: "0px auto"
          }}
          width="100%"
          height="100%"
        >
          <VictoryLegend
            title={this.props.title}
            standalone={false}
            colorScale={this.props.colors}
            x={0}
            y={0}
            gutter={10}
            data={this.props.labels}
            orientation="horizontal"
            itemsPerRow={4}
            style={{ title: { fontSize: 24 }, labels: { fontSize: 16 } }}
          />
          <VictoryPie
            standalone={false}
            animate={{ duration: 1000 }}
            padding={{
              top: 140,
              bottom: 40
            }}
            width={400}
            height={400}
            data={this.props.data}
            labels={d => Math.round(d.y)}
            labelRadius={80}
            style={{ labels: { fontSize: 16, fill: "white" } }}
            colorScale={this.props.colors}
          />
        </svg>
      </div>
    );
  }
}

export default PieChart;
